/* Black Deer — Davranış ve hata takibi
   Satış hunisindeki niyet sinyallerini ve tema hatalarını kaydeder.
   Kişisel veri toplanmaz: arama terimi yerine karakter sayısı gönderilir. */
(function(){
  function yaz(olay, veri){
    var d = Object.assign({ event: olay }, veri || {});
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(d);
    window.dispatchEvent(new CustomEvent('bd:analitik', { detail: d }));
  }
  var sayfa = (document.querySelector('main') || {}).dataset
    ? document.querySelector('main').dataset.template : '';

  // Arama: terim değil, uzunluk
  document.addEventListener('submit', function(e){
    var f = e.target;
    if (!(f instanceof HTMLFormElement)) return;
    if (!f.matches('form[action*="/search"], .search-form')) return;
    var g = f.querySelector('input[name="q"], input[type="search"]');
    yaz('bd_arama', { uzunluk: (g && g.value || '').trim().length, sayfa: sayfa });
  });

  // Filtre kullanımı
  document.addEventListener('change', function(e){
    var t = e.target;
    if (t && t.closest && t.closest('[data-bdg-panel], facets-form-component')) {
      yaz('bd_filtre', { alan: t.getAttribute('name') || '', sayfa: sayfa });
    }
  });

  // Niyet sinyalleri
  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-bdq-ac], .bdq-ac')) yaz('bd_hizli_bakis');
    if (t.closest('.bdbb__s')) yaz('bd_beden_bulucu_adim');
    if (t.closest('.bdsb__gonder')) yaz('bd_stok_bildirim');
    if (t.closest('.bdm__link')) yaz('bd_mega_menu_tikla');
    if (t.closest('.bdsg2__k')) yaz('bd_son_bakilan_tikla');
    if (t.closest('[data-bdb-go]')) yaz('bd_birlikte_al');
  });

  // Ürün kartı görüntülenme (sadece gerçekten görülenler)
  if ('IntersectionObserver' in window) {
    var izleyici = new IntersectionObserver(function(girdiler){
      girdiler.forEach(function(g){
        if (!g.isIntersecting) return;
        izleyici.unobserve(g.target);
        var a = g.target.querySelector('a[href*="/products/"]');
        var m = a && (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
        if (m) yaz('bd_urun_goruntulendi', { urun: m[1] });
      });
    }, { rootMargin: '80px', threshold: 0.3 });
    setTimeout(function(){
      document.querySelectorAll('.bdk2, .bdp__card').forEach(function(k){ izleyici.observe(k); });
    }, 500);
  }

  // Tema hataları (sadece kendi alan adımızdan)
  window.addEventListener('error', function(e){
    if (!e.filename || String(e.filename).indexOf(location.host) === -1) return;
    yaz('bd_tema_hatasi', {
      mesaj: String(e.message || '').slice(0, 160),
      dosya: String(e.filename).split('/').pop(),
      satir: e.lineno
    });
  });
})();
